/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Modal, Input, Select, Checkbox, message, Upload,} from 'antd';
import *as actions from "../../actions/notice"
import CustomTable, {TitleIcon} from "../components/customTable/CustomTable";
import * as utils from "../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../components/upload/UploadWall";
import {ATTCHMENT_TYPE, AUDIO_TYPE, FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../constants";
import ChunkUpload from "../../components/upload/ChunkUpload";
import {checkFileStatus} from "../../actions/upload";
import Editor from "../components/editor/Editors";
import {applicationName} from "../../utils";

const {Search} = Input;
const {Option} = Select;
export default class EditNotice extends Component {
    static defaultProps = {
        newSecondSelectColor:'#0050B3'
    };

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            editVisible: false,
            title: '',
            departId: 'all',
            departList: [],
            selectDepart: '',
            visible: false,
            start: 1,
            size: 10,
            count: 0,
            userList: [],
            userSelect: [],
            currentPageChooseStatus: false,
            currentNum: 0,
            status: 0,
            isAdd: false,
            id: '',
            fileList: [],
            content: '',//编辑器内容
            isUpDate: false,//是否更新子组件，回调函数不加，组组件会无线进入死循环，消耗内存，报错，这个为了解决子组件报错,
            searchValue: '',//搜索文字
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.actions.getDeptList((data) => {
            if (data.length > 0) {
                this.setState({departList: data, selectDepart: 'd_' + data[0].id});
            }
        });
        this.getUserList();
    }

    //获取用户列表
    getUserList() {
        let body = {
            start: this.state.start,
            size: this.state.size
        };
        if (this.state.searchValue) {
            body.userName = this.state.searchValue
        }
        this.state.currentPageChooseStatus = false;
        let count=0;
        this.state.userList=[];
        this.actions.getUserAllList(body, (data) => {
            if (data && data.data && data.data.length > 0) {
                this.state.userList = data.data;
                // this.revertDefaultUser();
                let num = data.data.length;
                let currentNum = 0;
                this.state.userList.forEach((Item, Index) => {
                    Item.checked = false;
                    this.state.userSelect.forEach((item, i) => {
                            if (Item.account === item) {
                                Item.checked = true;
                                currentNum++
                            }
                        }
                    )
                });
                this.state.currentNum = currentNum;
                if (num === currentNum) {
                    this.state.currentPageChooseStatus = true;
                }
                count=data.count;
            }
            this.setState({count: data.count})
        })
    }


    editShow(parms) {
        //console.log(parms)//
        this.state.start = 1;
        this.state.size = 10;
        this.state.searchValue = '';
        this.getUserList();
        if (parms && parms.isAdd) {
            this.state.start = 1;
            this.state.size = 10;
            this.getUserList();
            this.setState({
                isAdd: true,
                title: '',
                userSelect: [],
                status: 0,
                departId: 'all',
                editVisible: true,
                id: '',
                content: '',
                fileList: [],
                selectDepart: 'd_' + this.state.departList[0].id,
                isUpDate: true,
            })
        } else {
            let departId = parms.chooseType;
            this.state.selectDepart = 'd_' + this.state.departList[0].id;
            this.state.userSelect = [];
            if (parms.chooseType === 'd_') {
                this.state.selectDepart = parms.publishValue;//部门赋值
            }
            let newSelect=[];
            if (parms.chooseType === 'u_') {
                //this.state.userSelect = parms.publishValue.split(',');
                parms.publishValue.split(',').forEach(item=>{
                    newSelect.push(item.slice(2))
                    //item=item.slice(2);//去掉数据u_
                })
            }
            this.state.userSelect=newSelect;
            this.state.start = 1;
            this.state.size = 10;
            this.getUserList();
            let formdata = new FormData();
            formdata.append("notificationid", parms.id);
            let fileList = [];
            this.actions.getAttachmentFile(formdata, (data) => {
                data && data.map(item => {
                    fileList.push({
                        resourceId: item.resourceId,
                        uid: parseInt(item.id) * -1,
                        name: item.name,
                        status: 'done',
                        url: item.path,
                        path:item.path,
                    })
                });
                this.setState({fileList: fileList})
            });
            this.actions.getNotificationById(formdata, (data) => {
                this.setState({content: data.content ? data.content : '', isUpDate: true})
            });
            this.setState({
                isAdd: false,
                title: parms.title,
                status: parms.status,
                departId: departId,
                editVisible: true,
                id: parms.id,

            })
        }
        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });

    }

    render() {
        let titleKeyList =
            [{
                key: 'id',
                titleName: <div><Checkbox checked={this.state.currentPageChooseStatus} onChange={() => {
                    this.allClick()
                }}/></div>,
                width: 100,
                align: 'left',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div>
                            <Checkbox checked={record.checked} onChange={() => {
                                this.userItemClick(record, index)
                            }}/>
                        </div>

                    )
                }
            },
                {
                    key: 'key',
                    titleName: '编号',
                    width: 100,
                    align: 'left',
                    ellipsis: true,
                    render: (text, record, index) => {
                        return (<div>
                                {(this.state.start - 1) * this.state.size + index + 1}
                            </div>

                        )
                    }
                }, {
                key: 'account',
                titleName: '用户账号',
                width: 150,
                align: 'left',

            },
                {
                    key: 'name',
                    titleName: '用户姓名',
                    width: 150,
                    align: 'left',

                },
                {
                    key: 'allDept',
                    titleName: '部门',
                    width: 200,
                    align: 'center',
                    render: (text, record, index) => {
                        return (<div>
                                {record.allDept[0].name}
                            </div>

                        )
                    }
                },
            ];
        let newSecondSelectColor=this.props.newSecondSelectColor;

        return (
            <div>
                <Modal
                    title={null}
                    visible={this.state.editVisible}
                    onOk={() => {
                    }}
                    width={window.document.body.clientWidth * 0.9}
                    onCancel={() => {
                        this.setState({editVisible: false})
                    }}
                    footer={<div>
                        <Button onClick={() => {
                            if (this.state.isAdd) {
                                this.state.status = 1;
                            } else {
                                this.state.status = -1;
                            }
                            this.tempSave()
                        }}>{this.state.isAdd ? '暂存' : '保存'}</Button>
                        <Button type="primary"  style={{marginLeft: 20,background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} onClick={() => {
                            this.state.status = 3;
                            this.tempSave()
                        }}>发布</Button>
                    </div>}
                >

                    <div className={'notice'} style={{height: (parseInt(window.document.body.clientHeight * 0.9) - 213 + "px"), background: '#ffffff',overflow:'hidden',position:'relative'}}>
                        <Scrollbars auoWidth ref={(scrollRef) => {
                            this.scrollRef = scrollRef
                        }}>
                            <div style={{overflow:'hidden'}}>
                              <div> <div style={{display: 'flex', paddingTop: 20}}>
                                  <div style={{display: 'flex'}}>
                                      <div style={{display: 'flex', height: 32, lineHeight: '32px'}}><span
                                          style={{color: 'red',}}>*</span>
                                          <div style={{width: 32}}>标题</div>
                                      </div>
                                      <Input placeholder="请输入标题" value={this.state.title} onChange={(e) => {
                                          this.setState({title: e.target.value})
                                      }} style={{width: 300, marginLeft: 40}}/></div>
                                  <div style={{display: 'flex',}}>
                                      <div style={{height: 32, lineHeight: '32px', marginLeft: 20, width: 60}}>
                                          发布对象
                                      </div>
                                      <Select
                                          value={this.state.departId}
                                          style={{width: 150, marginLeft: 20}}
                                          onChange={(e) => {
                                              this.state.departId = e;
                                              this.setState({})
                                          }}>
                                          <Option value={'all'}>全部</Option>
                                          <Option value={'report'}>记者</Option>
                                          <Option value={'depart'}>二级部门</Option>
                                          <Option value={'d_'}>指定部门</Option>
                                          <Option value={'u_'}>指定个人</Option>
                                      </Select>
                                      {
                                          this.state.departId === 'd_' ? <Select
                                              value={this.state.selectDepart}
                                              style={{width: 150, marginLeft: 20}}
                                              onChange={(e) => {
                                                  this.state.selectDepart = e;
                                                  this.setState({})
                                              }}>
                                              {this.state.departList.map((item, i) => {
                                                  return (
                                                      <Option key={i} value={'d_' + item.id}>{item.name}</Option>
                                                  )

                                              })

                                              }
                                          </Select> : null
                                      }
                                      {this.state.departId === 'u_' ? <div onClick={() => {
                                          this.setState({
                                              visible: true, start: 1,
                                              size: 10,
                                          })
                                      }}>
                                          <Input placeholder="请点击选择" readOnly={true}
                                                 value={this.state.userSelect.toString()}
                                                 style={{width: 150, marginLeft: 20, color: 'black'}}/>
                                      </div> : null}


                                  </div>
                              </div>
                                  <div style={{display: 'flex', paddingTop: 20}}>
                                      <div style={{display: 'flex', height: 32, lineHeight: '32px'}}>
                                          <div style={{width: 60}}>公告附件</div>
                                      </div>
                                      <div style={{marginLeft: 20}}>
                                          <UploadWall
                                              accept={"." + FILE_TYPE.join(",.")}
                                              multiple={true}
                                              action="/cm-sites-pms/index/uploadFile"
                                              listType="list"
                                              fileList={this.state.fileList}
                                              customRequest={new ChunkUpload({
                                                  checkFileURL: "/cm-sites-" + applicationName() + "/index/checkFile",
                                                  checkChunkURL: "/cm-sites-" + applicationName() + "/index/checkChunk",
                                                  uploadChunkURL: "/cm-sites-" + applicationName() + "/index/uploadChunks",
                                                  chunkUploadOverURL: "/cm-sites-" + applicationName() + "/index/chunkUploadOver",
                                                  mergeChunksURL: "/cm-sites-" + applicationName() + "/index/mergeChunks"
                                              }).start}
                                              icons={["download", "delete"]}
                                              uploadBtnName={"上传附件"}
                                              onChange={this.handleChangeFileList}
                                              onRemove={this.handleRemove}
                                              onDownload={(file) => {
                                                  if (file.path.indexOf("?") === -1) {
                                                      window.location.href = file.path + "?download=1";
                                                  } else {
                                                      window.location.href = file.path + "&download=1";
                                                  }
                                              }}
                                          />
                                      </div>
                                  </div></div>


                            <div className={'edit'} style={{paddingRight:10}}>
                                <Editor
                                    customHeight={(parseInt(window.document.body.clientHeight * 0.95) - 213-125-100)}
                                    content={this.state.content}
                                    isShowMedia={false}
                                    isUpDate={this.state.isUpDate}
                                    callBackeditorContent={(data) => {
                                        this.setState({content: data, isUpDate: false})
                                    }}
                                />
                            </div>
                            </div>
                        </Scrollbars>
                    </div>
                </Modal>
                <Modal
                    title="选择用户"
                    visible={this.state.visible}
                    onOk={() => this.handleOk()}
                    width={1000}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                >
                    <div style={{height: '65vh'}}>
                        <div style={{position: 'relative', display: 'flex', height: 32, lineHeight: '32px'}}>
                            <div style={{marginLeft: 20}}>选择用户</div>
                            <div style={{position: 'absolute', right: 20}}><Search
                                placeholder="请输入用户名"
                                enterButton="搜索"
                                value={this.state.searchValue}
                                onChange={(e) => {
                                    this.setState({
                                        searchValue: e.target.value
                                    })
                                }}
                                size="default"
                                onSearch={value => this.onSearch(value)}
                            /></div>
                        </div>
                        <Scrollbars>
                            <CustomTable
                                dataSource={this.state.userList}
                                titleKeyList={titleKeyList}
                                //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                                pagination={{
                                    showQuickJumper: true,
                                    total: this.state.count,
                                    onChange: (page, pageSize) => {
                                        this.paginationChange(page, pageSize)
                                    }, onShowSizeChange: (page, pageSize) => {
                                        this.paginationChange(page, pageSize)
                                    },
                                    showTotal: total => `共 ${total} 条数据`,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '30', '40'],
                                    position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                                }}
                                onRow={(record, index) => {
                                    return {
                                        onClick: event => {
                                            // console.log('onclickItem', record, index)
                                        }, // 点击行
                                        onDoubleClick: event => {
                                        },
                                        onContextMenu: event => {
                                        },
                                        onMouseEnter: event => {
                                        }, // 鼠标移入行
                                        onMouseLeave: event => {
                                        },
                                    };
                                }}
                                locale={{emptyText: '暂无人员'}}

                            />
                        </Scrollbars>
                    </div>
                </Modal>

            </div>
        )
    }

    onSearch(value) {
        this.state.searchValue = value;
        this.state.start = 1;
        this.state.size = 10;
        this.getUserList();
    }

    handleChangeFileList = ({file, fileList}) => {
        if (file.status === "done") {
            this.checkStatus(file.response.storageFile.md5, (stateStr) => {
                let newFileList = fileList.map(item => {
                    if (item.uid === file.uid) {
                        item.url = "";
                        item.path = file.response.url;
                        item.ingStatus = stateStr;
                    }
                    return item;
                });
                this.setState({fileList: newFileList});
            }, (response) => {
                file.response = response;
                this.saveFile(file).then(res => {
                    let newFileList = fileList.map(item => {
                        if (item.uid === file.uid) {
                            item.url = file.response.url;
                            item.path = file.response.url;
                            item.resourceId = res.resourceId;
                            item.icon = <img src={file.response.url} width={70} height={90}/>;
                        }
                        return item;
                    });
                    this.setState({fileList: newFileList});
                }).catch(err => {
                    message.error("附件存放媒资库中出错");
                });
            });
        }
        console.log(fileList)
        this.setState({fileList});
    };

    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack) {
        setTimeout(() => {
            checkFileStatus(md5).then(res => {
                if (res.state !== "mergeComplete") {
                    this.checkStatus(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack({});
            });
        }, 100);//每隔一秒钟进行检查一次
    }

    saveFile(file) {
        let result = file.response;
        let url;
        let fileTemp = {};
        let params = {};
        let files = [];
        fileTemp.dataSource = 9;
        fileTemp.name = result.storageFile.name;
        fileTemp.ext = result.storageFile.suffix;
        fileTemp.path = result.url;
        fileTemp.size = result.storageFile.size ? result.storageFile.size : file.size;
        fileTemp.storyId = 0;
        fileTemp.md5 = result.storageFile.md5;
        if (PIC_TYPE.indexOf(result.storageFile.suffix) !== -1) {
            url = "/cm-sites-pms/storyNew/saveStoryFilePicture";
            fileTemp.imageHeight = result.storageFile.height;
            fileTemp.imageWidth = result.storageFile.width;
            files.push(fileTemp);
            params.pictures = files;
        } else if (VIDEO_TYPE.indexOf(result.storageFile.suffix) !== -1) {
            url = "/cm-sites-pms/storyNew/saveStoryFileVideo";
            fileTemp.frameHeight = result.storageFile.height;
            fileTemp.frameWidth = result.storageFile.width;
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.videos = files;
        } else if (AUDIO_TYPE.indexOf(result.storageFile.suffix) !== -1) {
            url = "/cm-sites-pms/storyNew/saveStoryFileAudio";
            fileTemp.allTime = result.storageFile.duration;
            files.push(fileTemp);
            params.audios = files;
        } else if (ATTCHMENT_TYPE.indexOf(result.storageFile.suffix) !== -1) {
            url = "/cm-sites-pms/storyNew/saveStoryFileOtherfile";
            files.push(fileTemp);
            params.otherFiles = files;
        }
        return new Promise((resolve, reject) => {
            window.$.ajax({
                type: "post",
                url: url,
                cache: false,
                // async: false,
                data: JSON.stringify(params),
                dataType: "json",
                contentType: 'application/json;charset=UTF-8',
                success: function (res) {
                    resolve(res[0]);
                }, error: function (err) {
                    console.log("err:    ", err);
                    reject(err);
                }
            });
        });
    }

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item => {
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    handleOk() {
        this.setState({visible: false})
    }

    paginationChange(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        this.getUserList();
    }

    //点击每一行选中
    userItemClick(record, index) {
        let currentNum = this.state.currentNum;
        if (record.checked) {
            this.state.userSelect.forEach((item, i) => {
                    if (item === record.account) {
                        this.state.userSelect.splice(i, 1)
                    }
                }
            );
            currentNum--;
        } else {
            currentNum++;
            this.state.userSelect.push(record.account)
        }
        if (currentNum === this.state.userList.length) {
            this.state.currentPageChooseStatus = true;
        } else {
            this.state.currentPageChooseStatus = false;
        }
        this.state.currentNum = currentNum;
        this.state.userList[index].checked = !record.checked;
        this.setState({});
    }

    //点击当前全部选中
    allClick() {
        if (this.state.currentPageChooseStatus) {
            this.state.userList.forEach((Item, Index) => {
                Item.checked = false;
                this.state.userSelect.forEach((item, i) => {
                        if (Item.name === item) {
                            this.state.userSelect.splice(i, 1)
                        }
                    }
                )
            });
            this.state.currentNum = 0;
        } else {
            this.state.userList.forEach((item, index) => {
                item.checked = true;
                let isIn = this.state.userSelect.indexOf(item.account);
                if (isIn < 0) {
                    this.state.userSelect.push(item.account)
                }
            })
            this.state.currentNum = this.state.userList.length;
            //this.state.userSelect.push(record.name)
        }
        this.state.currentPageChooseStatus = !this.state.currentPageChooseStatus;
        this.setState({});
    }

    //暂存
    tempSave() {
        if (this.state.title.trim().length === 0) {
            message.warn('请输入标题');
            return
        }
        let chooseRange = this.state.departId;
        if (this.state.departId === "d_") {
            chooseRange = this.state.selectDepart
        }
        if (this.state.departId === "u_") {
            chooseRange='';

            this.state.userSelect.forEach(item=>{
                chooseRange=chooseRange+'u_'+item+','
            });
            //chooseRange = this.state.userSelect.toString()
        }

        if (!chooseRange) {
            message.warn('请输选择发布对象');
            return
        }
        if (this.state.content === '' || this.state.content === '<p></p>') {
            message.warn('请输入内容');
            return
        }
        let attachmentResourceIds = '';
        if (this.state.fileList.length > 0) {
            this.state.fileList.forEach(item => {
                attachmentResourceIds = attachmentResourceIds + item.resourceId + ','
            })
        }
        if (this.state.isAdd) {
            let formdata = new FormData();
            formdata.append("content", this.state.content);
            formdata.append("title", this.state.title);
            formdata.append("summary", '');
            formdata.append("status", this.state.status);
            formdata.append("chooseRange", chooseRange);
            formdata.append("chooseType", this.state.departId);
            formdata.append("attachmentResourceIds", attachmentResourceIds);
            this.actions.addNotification(formdata, (data) => {
                this.setState({editVisible: false,});
                this.props.callBack && this.props.callBack();
            })
        } else {
            let formdata = new FormData();
            formdata.append("content", this.state.content);
            formdata.append("title", this.state.title);
            formdata.append("notificationid", this.state.id);
            formdata.append("status", this.state.status);
            formdata.append("chooseType", this.state.departId);
            formdata.append("attachmentResourceIds", attachmentResourceIds);
            // if(this.state.status===3){
            formdata.append("receiver", chooseRange);
            //}
            this.actions.editNotification(formdata, (data) => {
                this.setState({editVisible: false,});
                this.props.callBack && this.props.callBack();
            })

        }

    }

}